jQuery(function () {
  jQuery(".toggleMenu").on("click", function () {
    jQuery(this).toggleClass("opened");
    jQuery(this).next().slideToggle();
  });
});

jQuery(function ($) {
  $("a[href^=https]")
    .not('[href*="' + location.hostname + '"]')
    .attr("target", "_blank");
});

$(function () {
  if ($(".category_imgs_wrap").length) {
    $(".CollectionInner").addClass("category_imgs_wrap_display_none");
  } else {
    $(".PageHeader--withBackground").addClass("hidden-sp2");
  }
});

$(function () {
  $(".cpb_cq_1 input:radio").change(function () {
    if ($("[class=typeA_Y]").prop("checked")) {
      $(".cpb_cq_1_2").fadeIn();
    } else if ($("[class=typeA_N]").prop("checked")) {
      $(".cpb_cq_1_2").fadeOut();
    }
  });
});

// $(function() {
//     var q_value_load = $('.QuantitySelector__CurrentQuantity').val();
//     if( $('.QuantitySelector__CurrentQuantity').val() >= 6){
//       alert("1つの商品につき、1日の購入数は5個までとなります");
//       $(this).val('5');
//     }
// });

$(function () {
  $(".QuantitySelector__CurrentQuantity").on("mouseup keyup", function (e) {
    var q_value = $(this).val();
    if (q_value >= 6) {
      alert("1つの商品につき、1日の購入数は5個までとなります");
      $(this).val("5");
    }
  });
});

$(function () {
  $(".QuantitySelector__CurrentQuantity").change(function () {
    var q_value = $(this).val();
    if (q_value >= 6) {
      alert("1つの商品につき、1日の購入数は5個までとなります");
      $(this).val("5");
    }
  });
});

$(function () {
  $('[data-action="increase-quantity"]').click(function () {
    var q_value = $(this).prev().val();
    if (q_value >= 5) {
      alert("1つの商品につき、1日の購入数は5個までとなります");
      $(this).prev().val("4");
    }
  });
});

$(function () {
  $(".CartItem__QuantitySelector input").change(function () {
    var q_value_cart = $(this).val();
    if (q_value_cart >= 6) {
      $(".Cart__Checkout").addClass("quantity_over");
    }
  });
});

jQuery(function () {
  jQuery(".texture_list a").each(function () {
    var tobj = jQuery(this);
    var tlink = tobj.attr("href");
    tobj.attr("href", tlink + "#shopify-section-product-template");
  });
});

// 事前カウンセリング
var cpb_counseling_status = $.cookie("cpb_counseling_status");
if (cpb_counseling_status) {
  $("body").addClass(cpb_counseling_status);
}

$(function () {
  if (cpb_counseling_status == "ccs_ok") {
    $(".resultA").hide();
    $(".cart_result").fadeIn();
    $(".cpb_counseling_box").hide();
    $(".cpb_counseling_base").hide();
  } else if (cpb_counseling_status == "ccs_out") {
    $(".resultB").fadeIn();
    $(".cpb_counseling_base").hide();
  }
});

$(function () {
  //ボタンがクリックされた時
  $("button.cpb_btn_next").click(function () {
    //一度結果を非表示にする
    $(".result").hide();
    $(".cart_result").hide();
    //問題数を取得
    var qNum = $("ul.cpb_counseling_q_list li").length;
    //チェックされているinputの数を取得
    var typeA_Y_Num = $(".typeA_Y:checked").length,
      typeA_N_Num = $(".typeA_N:checked").length,
      typeB_Y_Num = $(".typeB_Y:checked").length,
      typeB_N_Num = $(".typeB_N:checked").length,
      typeC_Y_Num = $(".typeC_Y:checked").length,
      typeC_N_Num = $(".typeC_N:checked").length;

    if ($("ul.cpb_counseling_q_list li.cpb_cq_1 input:checked").length < 1) {
      //質問1にチェックしていなかったらアラートを出す
      alert("未回答の質問があります1");
    } else if (
      $("ul.cpb_counseling_q_list li.cpb_cq_2 input:checked").length < 1
    ) {
      //質問2にチェックしていなかったらアラートを出す
      alert("未回答の質問があります2");
    } else if (typeA_Y_Num == 1 && typeB_Y_Num == 0 && typeB_N_Num == 0) {
      //質問1にはいのとき、質問1-2にチェックしていなかったらアラートを出す
      alert("未回答の質問があります3");
    } else {
      if (typeA_N_Num == 1 && typeC_N_Num == 1) {
        //購入可
        $.cookie("cpb_counseling_status", "ccs_ok");
        $(".resultA").fadeIn();
        $(".cart_result").fadeIn();
        $(".cpb_counseling_base").fadeOut();
      } else if (typeA_Y_Num == 1 && typeB_N_Num == 1) {
        //購入不可
        $.cookie("cpb_counseling_status", "ccs_out");
        $(".resultB").fadeIn();
        $(".cpb_counseling_base").fadeOut();
      } else {
        //注意喚起付き購入可
        $.cookie("cpb_counseling_status", "ccs_ok");
        $(".resultC").fadeIn();
        $(".cart_result").fadeIn();
        $(".cpb_counseling_base").fadeOut();
      }
    }
  });
  $(".result_total_c_close").click(function () {
    $(".cpb_counseling_title").fadeOut();
    $(".cpb_counseling_box").fadeOut();
  });
});

// Padding調整
$(function () {
  if($('.id-alignment-block').length){
    $('.id-alignment-block').parent().parent().parent().css({"padding-top": "0px"});
    }
});

// ID連携リンク
$(function () {
  if($('.id_alignment_link').length){
    if($("#sidebar-cart .customerID").val() == ""){
      $('.id_alignment_link').attr("href", "/account/login")
    }
    }
});

// ID連携モーダル
$(function () {
  //ボタンがクリックされた時
  $("#id_modal_trigger").click(function () {
    $("#id_modal").fadeIn();
    var bodyHeight = $("body").outerHeight();
    $("#id_modal .id_modal_back").css("height", bodyHeight);
  });

  $("#id_modal .idm_close").click(function () {
    $("#id_modal").fadeOut();
  });
});

// カートページID連携モーダル
$(function () {
  //ボタンがクリックされた時
  $(document).on("click", "#cart_id_modal_trigger", function () {
    $("body").css("position", "relative");
    $("#cart_id_modal").fadeIn();
    var bodyHeight = $("body").outerHeight();
    $("#cart_id_modal .id_modal_back").css("height", bodyHeight);
    var scrollTop = $(window).scrollTop();

    //取得した値をcssに追加する
    $("#cart_id_modal .id_modal_inner").css({
      "top": scrollTop + "px"
});
  });

  $(document).on("click", "#cart_id_modal .idm_close", function () {
    $("#cart_id_modal").fadeOut();
  });
});



$(function () {
  var REDIRECT_PATH = '/pages/id_alignment_guidance';

  var selector = '#customer_login, form[action$="/account/login"][method="post"]',
    $form = document.querySelectorAll(selector)[0];

  if ($form) {
    $redirect = document.createElement('input');
    $redirect.setAttribute('name', 'return_url');
    $redirect.setAttribute('type', 'hidden');
    $redirect.value = REDIRECT_PATH;
    $form.appendChild($redirect);
  }
  });

$(function() {
    $('.fixed_bnr__close').click(function() {
      $(this).hide();
      $(".fixed_bnr").hide();
    });
});
